import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { toast } from 'sonner';
import { Input } from '../../components/ui/input';
import { Button } from '../../components/ui/button';
import { Eye, EyeOff } from 'lucide-react';

const AdminLogin = () => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const result = await login(credentials.username, credentials.password);
    
    if (result.success) {
      toast.success('Login efetuado com sucesso!');
      navigate('/admin');
    } else {
      toast.error(result.error);
    }
    
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center section-padding" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-20 h-20 mx-auto mb-6 bg-white rounded-full flex items-center justify-center">
            <span className="font-heading font-black text-black text-2xl">GDR</span>
          </div>
          <h1 className="font-heading text-3xl font-black">ÁREA DE ADMINISTRAÇÃO</h1>
          <p className="text-gray-400 mt-2">GDR Esporões</p>
        </div>

        <div className="bg-[#0A0A0A] border border-white/10 p-8">
          <form onSubmit={handleSubmit} className="space-y-6" data-testid="login-form">
            <div>
              <label className="block text-xs uppercase tracking-widest text-gray-400 font-bold mb-2">
                Utilizador
              </label>
              <Input
                type="text"
                value={credentials.username}
                onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
                required
                className="bg-black/50 border-white/10 focus:border-white/30 rounded-none"
                placeholder="Introduza o utilizador"
                data-testid="login-username"
              />
            </div>

            <div>
              <label className="block text-xs uppercase tracking-widest text-gray-400 font-bold mb-2">
                Palavra-passe
              </label>
              <div className="relative">
                <Input
                  type={showPassword ? 'text' : 'password'}
                  value={credentials.password}
                  onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                  required
                  className="bg-black/50 border-white/10 focus:border-white/30 rounded-none pr-10"
                  placeholder="Introduza a palavra-passe"
                  data-testid="login-password"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-white"
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-white text-black hover:bg-gray-200 rounded-none uppercase font-bold tracking-widest py-6"
              data-testid="login-submit"
            >
              {loading ? 'A ENTRAR...' : 'ENTRAR'}
            </Button>
          </form>
        </div>

        <p className="text-center text-gray-500 text-xs mt-6">
          <a href="/" className="hover:text-white transition-colors">
            ← Voltar ao site
          </a>
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
